import { render, staticRenderFns } from "./TaxReturnSupplySection.vue?vue&type=template&id=59f2020c&scoped=true&"
import script from "./TaxReturnSupplySection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnSupplySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f2020c",
  null
  
)

export default component.exports